<template>
  <div>
    <apexchart
        v-if="loaded"
        height="150"
        :width="chartWidth ? chartWidth : '100%'"
        type="radialBar"
        :options="chartOptions"
        :series="chartSeries"
    >
    </apexchart>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "RadialScore",
  components: {
    apexchart: () => import("vue-apexcharts")
  },
  props: {
    score: Object, // score object
    scoreIcon: String, // file name of icon, which should be used
    chartWidth: String, // width of the chart
  },
  data() {
    return {
      loaded: false,
      chartOptions: {
        chart: {
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '60%',
              image: '',
              imageWidth: 24,
              imageOffsetY: -10,
              imageClipped: false
            },
            dataLabels: {
              name: {
                offsetY: 20,
                color: this.getColor(this.score.percentage)
              },
              value: {
                show: false,
              }
            }
          },
        },
        stroke: {
          lineCap: "round"
        },
        labels: [],
        fill: {
          type: 'solid',
          colors: [this.getColor(this.score.percentage)],
        }
      },
      chartSeries: []
    }
  },
  watch: {
    score: {
      handler() {
        // for JS 0 == false
        let isPercentage = (typeof this.score.percentage !== 'undefined') && this.score.percentage != null;
        if (isPercentage && this.scoreIcon) {
          this.chartSeries[0] = this.score.percentage;
          this.chartOptions.labels[0] = this.score.fulfilled + " / " + this.score.required;

          // set icon with correct color
          this.chartOptions.plotOptions.radialBar.hollow.image = this.getFile(this.score.percentage);
          // set text color
          this.chartOptions.plotOptions.radialBar.dataLabels.name.color = this.getColor(this.score.percentage);
          // set bar color
          this.chartOptions.fill.colors[0] = this.getColor(this.score.percentage);

          Vue.set(this.chartSeries, 0, this.score.percentage);
          Vue.set(this.chartOptions.labels, 0, this.score.fulfilled + " / " + this.score.required);

          // we have to assign chartOptions with copy + changes
          // to see possible color changes in the interface
          // it is not possible with vue set because of nested object properties
          this.chartOptions = {
            ...this.chartOptions,
            'chartOptions.plotOptions.radialBar.hollow.image': this.chartOptions.plotOptions.radialBar.hollow.image,
            'chartOptions.plotOptions.radialBar.dataLabels.name.color': this.chartOptions.plotOptions.radialBar.dataLabels.name.color
          };

          Vue.set(this.chartOptions.fill.colors, 0, this.getColor(this.score.percentage))

          this.loaded = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getColor(percentage) {
      if(percentage < 25) {
        return '#df5e63'
      } else if (percentage >= 25 && percentage < 50) {
        return '#df8b5d'
      } else if (percentage >= 50 && percentage < 75) {
        return '#dfd95e'
      } else {
        return '#13be9c'
      }
    },

    // generate and get file name for image with matching percentage
    // to match the color of everything else
    // e.g. "@/assets/scoreIcons/building/building-25.svg"
    getFile(percentage) {
      if (percentage < 25) {
        return require(
            "@/assets/scoreIcons/" +
            this.scoreIcon +
            "/" + this.scoreIcon +
            "-25.svg")
      } else if (percentage >= 25 && percentage < 50) {
        return require(
            "@/assets/scoreIcons/" +
            this.scoreIcon +
            "/" + this.scoreIcon +
            "-50.svg")
      } else if (percentage >= 50 && percentage < 75) {
        return require(
            "@/assets/scoreIcons/" +
            this.scoreIcon +
            "/" + this.scoreIcon +
            "-75.svg")
      } else {
        return require(
            "@/assets/scoreIcons/" +
            this.scoreIcon +
            "/" + this.scoreIcon +
            ".svg")
      }
    }
  }
}
</script>